<template>
    <div>
        <lazy-load-component root-margin="600px 0px 600px 0px" @loaded="loadData()">
            <CarouselBox
                :products="products"
                :title="$t(amountInStock > 0 ? 'productDetail.tabs.similarTitle' : 'productDetail.tabs.similarTitleNotInStock')"
                :item-list-name="itemListName"
                class="carouselBox--fullWidth"
                :sticker-title="products[0]?.availabilityText"
            />
        </lazy-load-component>
        <SkeletonProductCarouselSkeleton v-if="!loaded" />
    </div>
</template>

<script lang="ts">
import CarouselBox from '~/components/elements/CarouselBox.vue'
import Product from '~/models/Product/Product'
import LazyLoadComponent from '~/components/LazyLoadComponent.vue'
import { GtmItemListNameEnum } from '~/models/DataLayer/GtmItemListNameEnum'
import LuigisBoxEventApi from '~/extensions/LuigisBoxEventApi'
import { transformProductsToLuigisBoxItems } from '~/utils/transformProductsToLuigisBoxItems'
import { useCookie } from '#imports'
import { useAbTestStore } from '~/stores/abTest'
import LuigisRecoTypes from '~/value/LuigisRecoTypes'

export default {
    components: {
        LazyLoadComponent,
        CarouselBox,
    },

    props: {
        productId: {
            type: Number,
            required: true,
        },
        productUrl: {
            type: String,
            required: true,
        },
        amountInStock: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            loaded: false,
            products: [] as Product[],
        }
    },

    computed: {
        itemListName(): string {
            return GtmItemListNameEnum.ProductDetailSimilarProducts
        },

        similarAbTestVariant(): number | null {
            const abTestStore = useAbTestStore()

            return abTestStore.getVariant('RecoDetailAlternativesAbTest')
        },
    },

    methods: {
        async loadData() {
            const isLuigisBoVariant = this.similarAbTestVariant === 0
            if (isLuigisBoVariant) {
                const response = await this.$repository.getRecoProducts(
                    LuigisRecoTypes.ITEM_DETAIL_ALTERNATIVES,
                    this.productId,
                    useUidCookie().value,
                    useCookie('_lb').value ?? ''
                )
                this.products = response.products
            } else {
                const response = await this.$repository.getProductSimilarProducts(this.productId, 1)
                this.products = response.products
            }
            this.loaded = true

            LuigisBoxEventApi.sendRecommendationEvent(
                transformProductsToLuigisBoxItems(this.products),
                this.$t('productDetail.tabs.similarTitle'),
                isLuigisBoVariant ? LuigisRecoTypes.ITEM_DETAIL_ALTERNATIVES : 'item_detail',
                this.productUrl,
                isLuigisBoVariant
            )
        },
    },
}
</script>
